// 一括投資提案の1リクエストあたり最大対象数。
// サーバー側の ConcernAgent::BulkInvestmentProposalConcern::MAX_TARGET_USER_COUNT と対で維持すること。
export const BULK_MAX_TARGET_USER_COUNT = 10000;
